<h2 mat-dialog-title>Controle de Séries</h2>

<mat-dialog-content>
  <div class="produto-info">
    <span class="produto-nome">{{ nomeProduto }}</span>
    @if (skuProduto) {
      <span class="produto-sku">SKU: {{ skuProduto }}</span>
    }
    <span class="status-badge badge-cinza status-qtd">
      {{ isNarrow ? 'Saldo sist.' : 'Saldo sistema' }}: {{ saldoSistema | number:'1.0-0' }}
      / {{ isNarrow ? 'Contado' : 'Total contado' }}: {{ totalContado }}
    </span>
  </div>

  @if (isLoading) {
    <div class="loading-row">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Carregando séries em estoque…</span>
    </div>
  }

  @if (erroCarga) {
    <div class="error-banner">{{ erroCarga }}</div>
  }

  @if (!isReadOnly) {
    <div class="bipe-form mt-2">
      <mat-form-field appearance="outline" class="field-bipe" subscriptSizing="dynamic">
        <mat-label>Digitar / bipar código da série</mat-label>
        <input #inputSerie matInput [(ngModel)]="novoCodigoSerie" placeholder="Ex: SER-001"
               (keydown.enter)="adicionarSerie()" />
        <mat-icon matSuffix>qr_code_scanner</mat-icon>
      </mat-form-field>
      <button mat-flat-button class="btn-primary" (click)="adicionarSerie()" [disabled]="!novoCodigoSerie.trim()">
        <mat-icon>add</mat-icon>
        Adicionar
      </button>
    </div>
    <p class="hint-text">
      Cada série equivale a 1 unidade. Adicionar uma série a registra como contada; remover registra contagem zero.
    </p>
  }

  @if (!isLoading && dataSource.data.length === 0) {
    <div class="empty-contacts">Nenhuma série em estoque nesta localização. Digite ou bipe o código acima.</div>
  } @else if (isNarrow) {
    <div class="modal-card-list">
      @for (row of dataSource.data; track row; let i = $index) {
        <div class="modal-card">
          <div class="modal-card__header">
            <div class="modal-card__ro modal-card__header-main" [class.removido]="row.isRemovido">
              <small>Código da Série</small>
              <span>
                {{ row.codigoSerie }}
                @if (!row.isExistente) {
                  <span class="badge-novo" matTooltip="Série nova (será criada no processamento)">nova</span>
                }
              </span>
            </div>
            @if (!isReadOnly) {
              @if (row.isRemovido) {
                <button mat-icon-button (click)="desfazerRemocao(i)" matTooltip="Restaurar série">
                  <mat-icon>undo</mat-icon>
                </button>
              } @else {
                <button mat-icon-button color="warn"
                  [matTooltip]="row.isExistente ? 'Remover (registra contagem zero)' : 'Remover linha'"
                  (click)="removerSerie(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            }
          </div>
          <div class="modal-card__body">
            <div class="modal-card__ro" [class.removido]="row.isRemovido">
              <small>Saldo Sistema</small>
              <span>{{ row.saldoSistema | number:'1.0-0' }}</span>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="table-responsive mt-2">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0 w-100 modal-tabela-cards">

        <ng-container matColumnDef="codigoSerie">
          <th mat-header-cell *matHeaderCellDef>Código da Série</th>
          <td mat-cell *matCellDef="let row" [class.removido]="row.isRemovido" [attr.data-label]="'Código da Série'">
            {{ row.codigoSerie }}
            @if (!row.isExistente) {
              <span class="badge-novo" matTooltip="Série nova (será criada no processamento)">nova</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="saldoSistema">
          <th mat-header-cell *matHeaderCellDef>Saldo Sistema</th>
          <td mat-cell *matCellDef="let row" [class.removido]="row.isRemovido" [attr.data-label]="'Saldo Sistema'">
            {{ row.saldoSistema | number:'1.0-0' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef class="text-end">Ações</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-acoes">
            @if (row.isRemovido) {
              <button mat-button (click)="desfazerRemocao(i)" matTooltip="Restaurar série">
                <mat-icon>undo</mat-icon>
                Desfazer
              </button>
            } @else {
              <button mat-icon-button color="warn"
                [matTooltip]="row.isExistente ? 'Remover (registra contagem zero)' : 'Remover linha'"
                (click)="removerSerie(i)">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  @if (!isReadOnly) {
    <button mat-flat-button class="btn-primary" (click)="confirmar()">Confirmar</button>
  }
</mat-dialog-actions>
